import { render, staticRenderFns } from "./UnvotedGmResolutionSelectModalContent.vue?vue&type=template&id=0401d71e&scoped=true&"
import script from "./UnvotedGmResolutionSelectModalContent.vue?vue&type=script&lang=ts&"
export * from "./UnvotedGmResolutionSelectModalContent.vue?vue&type=script&lang=ts&"
import style0 from "./UnvotedGmResolutionSelectModalContent.vue?vue&type=style&index=0&id=0401d71e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0401d71e",
  null
  
)

export default component.exports